import React, { useEffect } from 'react';
import { useLocation, Navigate } from 'react-router-dom';

import { Routes } from '@amzn/atoz-shiftapp-initializer';
import { logger } from '@amzn/atoz-shiftapp-metrics';
import { useAssociateContext } from '@amzn/atoz-shiftapp-utilities';

export const MissingRoute: React.FC = () => {
    const location = useLocation();
    const {
        features: { schedulePageEnabled }
    } = useAssociateContext();

    useEffect(() => {
        logger.emitWarn('Linked to route that does not exist', {
            context: { location }
        });
    }, [location]);

    return (
        <Navigate
            to={schedulePageEnabled ? Routes.MySchedule : Routes.Index}
            replace={true}
        />
    );
};
